import React from 'react';
import { UNAUTH_USER } from 'store/actionTypes';
import store from '../store';
import axios from 'axios';
import { toast } from 'react-toastify';
import CustomToast from 'components/common/CustomToast';

var join = require('url-join');

var isAbsoluteURLRegex = /^(?:\w+:)\/\//;

// axios.interceptors.request.use(function (config) {
//   // Concatenate base path if not an absolute URL
//   console.log('config', config.url);
//   if (!isAbsoluteURLRegex.test(config.url)) {
//     if (process.env.PLATFORM != 'production') {
//       // config.url = join("http", config.url);
//       config.url = join('http://localhost:8001', config.url);
//     }
//   }

//   return config;
// });

// axios instance with authorization header
export const axiosAuth = axios.create();

axiosAuth.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    console.log(
      'response in axios error handler',
      error?.response,
      error?.response?.data
    );
    if (error.response.status === 401 || error.response.status === 403) {
      toast(() => (
        <CustomToast
          toastType="error"
          message={
            error.response?.data?.message ||
            'Access forbidden. Please log in again'
          }
        />
      ));
      localStorage.clear();
      store.dispatch({ type: 'UNAUTH_USER' });
      setTimeout(() => {
        window.location.pathname !== '/login' &&
          window.location.replace('/login');
      }, 1500);
    }

    // Throw errr again (may be need for some other catch)
    return Promise.reject(error);
  }
);
//axios instance without header
export const axiosNoAuth = axios.create({
  headers: { 'Access-Control-Allow-Origin': '*' },
});

//axios middleware for adding token to api request
export function axiosAuthMiddleware({ dispatch, getState }) {
  console.log('axiosSetstate', getState());
  return (next) => (action) => {
    axiosAuth.interceptors.request.use(
      function (config) {
        // console.log("herer-");
        config.headers.Authorization = `Bearer ${getState().auth.token} `;
        // if (!isAbsoluteURLRegex.test(config.url)) {
        //   if (process.env.PLATFORM != 'production') {
        //     // config.url = join("http", config.url);
        //     config.url = join('http://localhost:3000', config.url);
        //   }
        // }
        return config;
      },
      function (error) {
        console.log('error', error);
        return Promise.reject(error);
      }
    );
    next(action);
  };
}
